/*import { CgGym } from "react-icons/cg"; */
import { BiRun } from "react-icons/bi";
import { AiFillFire } from "react-icons/ai";
import { BsFillHeartPulseFill } from "react-icons/bs";
import { GiStrong } from "react-icons/gi";
const Data = [
  {
    id: 1,
    imgIcon: <GiStrong />,
    title: "Strength Training",
    description:
      "Unlock your potential with tailored strength training. Join us to experience increased strength and empowerment.",
    footer: "Register Now ",
  },
  {
    id: 2,
    imgIcon: <BiRun />,
    title: "Cardio Training",
    description:
      "Maximize Your Cardiovascular Fitness. Join Our Cardio Training Program for Enhanced Stamina, Better Health, and a Happier You.",
    footer: "Register Now ",
  },
  {
    id: 3,
    imgIcon: <AiFillFire />,
    title: "Fat Burning",
    description:
      "Ignite Your Fat-Burning Journey. Enroll in Our Fat Burning Program for Improved Metabolism and a Leaner, Healthier You.",
    footer: "Register Now ",
  },
  {
    id: 4,
    imgIcon: <BsFillHeartPulseFill />,
    title: "Health Fitness",
    description:
      "Elevate Your Overall Health and Fitness Journey. Embrace Our Holistic Fitness Program for a Vibrant and Active Lifestyle.",
    footer: "Register Now ",
  },
];

export default Data;
